import { useLocation } from "@remix-run/react"
import { useEffect } from "react"
import { useAnalytics } from "~/providers/AnalyticsProvider"

export default function usePageTracking(category: string) {
  const { pathname } = useLocation()
  const { page } = useAnalytics()

  // Track page view.
  useEffect(() => {
    page(pathname, undefined, category)
  }, [pathname, page, category])
}
